<!--The content below is only a placeholder and can be replaced.-->

<mat-toolbar color="{{color}}">
  <mat-toolbar-row>
    <div fxLayout="column" fxLayoutAlign="center start" class="branding-container">
      <span class="tool-name">Remote AG Admin Tool - {{env}}</span>
      <span class="slack-info">
        Reach out to us on Slack!
        <a href="https://dojo.enterprise.slack.com/archives/C022AUS002Y" target="_blank" class="slack-link">
          #remote-ag-support
        </a>
      </span>
    </div>
    <app-links class="nav-links"></app-links>
    <span class="spacer"></span>

    <app-sign-out></app-sign-out>
  </mat-toolbar-row>
</mat-toolbar>

<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
  <router-outlet></router-outlet>
</div>
